import { format, intervalToDuration } from 'date-fns';

export const ROUTES = {
    LOGIN: '/',
    LOGOUT: '/logout',
    CRAFTSMAN_DETAILS: '/craftsman-details/:id',
    CRAFTSMAN_DETAILS_PATH: (id) => '/craftsman-details/' + id,
    USER_DETAILS: '/user-details/:id',
    USER_DETAILS_PATH: (id) => '/user-details/' + id,
    CRAFTSMAN_LIST: '/craftsman-list',
    USERS_LISTING: '/user-list',
    MESSAGES: '/messages',
    CONSULTATIONS_LIST: '/consultations',
    CREATE_STORE: '/create-store',
    EDIT_STORE:  '/edit-store/:id',
    EDIT_STORE_PATH: (id) => '/edit-store/' + id,
    STORES: '/stores',
    CONSULTATION_DETAILS: '/consultation-details/:id',
    CONSULTATION_DETAILS_PATH: (id) => '/consultation-details/' + id,

};

export const BEARER_TOKEN = '';

export const DATE_FORMAT = 'dd/MM/yyyy';
export const DATE_FORMAT_WITH_HOURS = 'dd.MM.yyyy hh:mm:ss';

export const ROLES = {
    CLIENT: 'client',
    CRAFTSMAN: 'craftsman',
    ADMIN: 'admin',
};

export const APP_BAR_ELEMENTS = {
    EXPERT: 'expert',
    USERS: 'users',
    CONSULTATION: 'consultations',
    MESSAGES: 'messages',
    CALLS: 'calls',
    PROFILE: 'profile',
    CREATE_STORE: 'create-store',
    STORES: 'stores',
};

export const APP_BAR_ACTIONS = {
    BACK: 'back',
    NONE: 'none',
};

export const FORMAT_HOURS_AND_MINUTES = (date) => format(date, 'HH:mm');

export const FORMAT_CONSULTATION_DATE = (date) => format(date, 'd MMM yyyy');

export const FORMAT_LAST_MESSAGE_DATE = (date) => format(date, 'dd/MM/yy');

export const FORMAT_CALLS_HISTORY_DATE = (date) =>
    format(date, 'dd MMM yyyy H:mm ');

export const MESSAGE_TIME = (date) => format(date, 'HH:mm');

export const CRAFTSMAN_STATUS = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    BLOCKED: 'BLOCKED',
};

export const MESSAGE_TYPES = {
    TEXT: 'text',
    CALL: 'call',
    FILE: 'file',
    PHOTOS: 'photos',
    DATE_DIVIDER: 'divider',
};

export const USER_STATUS = {
    ACTIVE: 'ACTIVE',
    BLOCKED: 'BLOCKED',
};

export const REQUEST_DURATION = {
    15: '15 min',
    30: '30 min',
    120: '2 hours',
};

export const REQUEST_TYPE = {
    15: 'Short (15 min)',
    30: 'Short (30 min)',
    120: 'Repair (2 hours)',
};

export const REQUESTS_TABS_KEY_WORDS = {
    REQUESTED: 'REQUESTED',
    APPROVED: 'APPROVED',
    ARCHIVED: 'ARCHIVED',
    CANCELED: 'CANCELED'
};

export const FORMAT_CONSULTATION_DETAILS_DATE = (date) =>
    format(date, 'dd/MM/yyyy');

export const REQUEST_STATES = {
    NEW: 'new',
    APPROVED: 'approved',
    DENIED: 'denied',
    CANCELED: 'canceled',
};

export const TODAY = new Date();

export const PAGINATION_LIMIT = 10;

export const GER_RECORDS_FROM_ROOM = (roomHash) =>
    'https://meet.diyassist.pro/api/v2/records/' + roomHash;

export const RECORDING_BASE_PATH = 'https://video.daskal.eu:444/';

export const FORMAT_DURATION = (time) => {
    const formattedObj = intervalToDuration({ start: 0, end: time * 1000 });

    const { seconds, minutes } = formattedObj;

    const milliseconds = Math.round((time % 1).toFixed(2) * 100).toString();

    const mins =
        minutes.toString().length < 2
            ? '0' + minutes.toString()
            : minutes.toString();
    const secs =
        seconds.toString().length < 2
            ? '0' + seconds.toString()
            : seconds.toString();
    const milSecs = milliseconds.length < 2 ? '0' + milliseconds : milliseconds;
    const result = `${mins}:${secs}:${milSecs}`;

    return result.substring(0, 8);
};

export const ERROR_MESSAGES = {
    EMAIL_INVALID: 'Email not valid',
    PASSWORD_SHORT: 'password must be at least 6 symbols',
    PASSWORD_NOT_EQUAL: 'passwords are not equal',
    FIRSTNAME_SHORT: 'First name missing',
    LASTNAME_SHORT: 'Last name missing',
    CITY: 'please enter City',
    COUNTRY: 'please enter Country',
    LANGUAGES: 'please select Language',
    SPECIALITY: 'please add Speciality',
    SECONDARY_SPECIALITIES: 'please add Other Qualification',
    INFO: 'Bio too short of missing',
    ACCEPT_TERMS: 'you need to accept',
    PHONE: 'phone number missing',
    STORE_NAME: 'store name missing',
    UIC: 'uic missing',
    SECURITY_TOKEN: 'security token missing',
    CONTACT_PERSON: 'contact person missing',
    CREDIT_ACCOUNTS: 'contact person missing',
    URL: 'URL missing'
};
